export const __DEV__ = import.meta.env.VITE_MODE === "development";
export const defaultLocaleCode = import.meta.env.VITE_DEFAULT_LOCALE_CODE;
export const fallbackLocaleCode = import.meta.env.VITE_DEFAULT_LOCALE_CODE;
export const appCode = import.meta.env.VITE_APP_CODE;
export const appName = import.meta.env.VITE_APP_NAME;
export const appPrefix = import.meta.env.VITE_APP_PREFIX;
export const productionBasePath = import.meta.env.VITE_BASE_PATH;
export const apiOS = import.meta.env.VITE_API_OS;
export const appVersion = import.meta.env.VITE_VERSION;
export const apiBaseUrl = import.meta.env.VITE_API_URL;
export const apiKey = import.meta.env.VITE_API_KEY;
export const googleMapApiKey = import.meta.env.VITE_GOOGLE_MAP_API_KEY;
export const facebookAppId = import.meta.env.VITE_FACEBOOK_APP_ID;
export const facebookAppVersion = import.meta.env.VITE_FACEBOOK_APP_VERSION;
export const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const maintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE;

// Configuration for handling settings API failures
export const settingsMaintenanceMode = import.meta.env.VITE_SETTINGS_MAINTENANCE_MODE === "true";
export const settingsFallbackMode = import.meta.env.VITE_SETTINGS_FALLBACK_MODE !== "false"; // Default to true
